"use client"

import { useEffect } from "react"

export function HubSpotMeetings({ meetingUrl }: { meetingUrl: string }) {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'
    script.async = true
    document.body.appendChild(script)

    // HubSpot's embed script injects an iframe with no title attribute, which
    // fails axe-core's frame-title rule. Watch for it and set an accessible name.
    const container = document.querySelector('.meetings-iframe-container')
    let observer: MutationObserver | null = null
    if (container) {
      observer = new MutationObserver(() => {
        const iframe = container.querySelector('iframe')
        if (iframe && !iframe.getAttribute('title')) {
          iframe.setAttribute('title', 'Schedule a HIPAA Ready Check demo')
        }
      })
      observer.observe(container, { childList: true, subtree: true })
    }

    return () => {
      observer?.disconnect()
      document.body.removeChild(script)
    }
  }, [])

  return (
    <div
      className="meetings-iframe-container"
      data-src={`${meetingUrl}?embed=true`}
      style={{ minHeight: '650px' }}
    />
  )
}
